import { TFunction } from 'i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import XLSX from 'sheetjs-style';
import { Countries } from 'shared/enums';
import { StoreCountriesData } from 'store/countriesDataStore';
import generateWorkbook from './generateWorkbook';
import { Currencies } from '../../shared/types';

export default (
  countriesData: StoreCountriesData,
  formData: StoreCountriesData,
  t: TFunction<'translation', undefined, 'translation'>,
  exchangeRates: any
) => {
  const workbook = XLSX.utils.book_new();
  const countries = [
    {
      code: Countries.CZECHIA,
      name: 'Czechia',
      data: countriesData.CZ,
      formData: formData.CZ.formData,
      currency: 'CZK' as Currencies,
    },
    {
      code: Countries.SLOVAKIA,
      name: 'Slovakia',
      data: countriesData.SK,
      formData: formData.SK.formData,
      currency: 'EUR' as Currencies,
    },
    {
      code: Countries.HUNGARY,
      name: 'Hungary',
      data: countriesData.HU,
      formData: formData.HU.formData,
      currency: 'HUF' as Currencies,
    },
  ];

  countries.forEach((country) => {
    const { code, name, data, formData: countryFormData, currency } = country;
    if (!isEmpty(data.estimatedBudget) && !isEmpty(data.parameters)) {
      const worksheet = generateWorkbook(
        data,
        countryFormData,
        t,
        code,
        currency,
        exchangeRates
      );
      XLSX.utils.book_append_sheet(workbook, worksheet, name);
    }
  });

  if (workbook.SheetNames.length === 0) {
    XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet([]), '');
  }

  XLSX.writeFile(workbook, `media-calculations-${moment().unix()}.xlsx`);
};
